export class Reaction {
  id: number;
  name: string;
}
